import React from 'react';
import Link from 'next/link';
import { useQuery } from '@apollo/client';
import { Menu, MenuItem } from '@bnnvara/menu';
import { track } from '@bnnvara/analytics/src/track';

import useSharedRef from '@/hooks/useSharedRef';
import { useBrandHubHeight } from '@/hooks/useBrandHubHeight';
import { SubNavigationQuery } from '@/api/queries/menu.gql';
import { useLink } from '@/components/Link';
import StyledSubNavigation from './styled';

const ThemeSubNavigation = () => {
  const { isCurrent } = useLink();
  const { loading, data } = useQuery(SubNavigationQuery, {
    variables: {
      slug: 'portal',
    },
  });

  const { createRef } = useSharedRef();
  const ref = createRef('subNavigation');
  const brandHubHeight = useBrandHubHeight();

  if (loading) return <Menu />;

  if (data?.brand?.menuItems?.length > 0) {
    const menuItems = [...data.brand.menuItems].sort(
      (a, b) => a.order - b.order
    );

    return (
      <StyledSubNavigation ref={ref} brandHubHeight={brandHubHeight}>
        <Menu>
          {!loading &&
            menuItems.map(({ id, slug, body, order }, index) => {
              const isActive = isCurrent(slug);

              const gaLabel = `${index}-${body.replace(/\s/g, '-')}`;

              return (
                <MenuItem order={order} key={id} isActive={isActive}>
                  <Link href={slug} passHref>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      role="link"
                      tabIndex="0"
                      onClick={() => {
                        track('themanavigatie', 'click', gaLabel);
                      }}
                      onKeyDown={() => {
                        track('themanavigatie', 'click', gaLabel);
                      }}
                    >
                      {body}
                    </a>
                  </Link>
                </MenuItem>
              );
            })}
        </Menu>
      </StyledSubNavigation>
    );
  }

  return null;
};

export default ThemeSubNavigation;
